import axios from 'axios'

export const userService = {
    login,
    logout,
    reset,
    verifyReset,
    resetPassword,
    create,
    list,
    update,
    remove,
    validate,
    rate
}

async function login (username, password) {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/users/authenticate`, { username, password })
        // authentication failed
        if (!response.data.token) {
            return Promise.reject(new Error('authentication failed'))
        }
        localStorage.setItem('user', JSON.stringify(response.data.user))
        localStorage.setItem('token', response.data.token)
        return Promise.resolve(response.data.user)
    } catch (error) {
        // request failed
        return Promise.reject(error)
    }
}

function logout () {
    // remove user and token from local storage to log user out
    localStorage.removeItem('user')
    localStorage.removeItem('token')
}

async function reset (username) {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/users/reset`, { username })
        return Promise.resolve(response.data.message)
    } catch (error) {
        // request failed
        return Promise.reject(error)
    }
}

async function verifyReset (token) {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/users/reset/${token}`)
        return Promise.resolve(response.data.message)
    } catch (error) {
        // request failed
        return Promise.reject(error)
    }
}

async function resetPassword (token, password) {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/users/reset/${token}`, { password })
        return Promise.resolve(response.data.message)
    } catch (error) {
        // request failed
        return Promise.reject(error)
    }
}

async function create (user) {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/users`, user)
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

async function list () {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/users`)
        return Promise.resolve(response.data.users)
    } catch (error) {
        return Promise.reject(error)
    }
}

async function update (id, data) {
    try {
        const response = await axios.patch(`${process.env.VUE_APP_API_URL}/users/${id}`, data)
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

async function remove (id) {
    try {
        const response = await axios.delete(`${process.env.VUE_APP_API_URL}/users/${id}`)
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

async function validate (candidate) {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/users/validate`, candidate)
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

async function rate (stars, text) {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/users/rate`, { stars, text })
        return Promise.resolve(response.data.message)
    } catch (error) {
        // request failed
        return Promise.reject(error)
    }
}
